export const environment = {
  production: true,
  versao: '1.19.8',
  // apiUrl: 'http://localhost:3000',
  // webSocketUrl: 'http://localhost:3000',
  apiUrl: 'https://api.bonnapp.com.br',
  webSocketUrl: 'https://api.bonnapp.com.br',
  nominatimUrl: 'https://nominatim.openstreetmap.org',
  cepAwesomeApiUrl: 'https://cep.awesomeapi.com.br',
};
